<template>
  <div class="row">
    <div class="col-md-12">
      <InputGroup
          label="Name"
          type="text"
          v-model="form.name"
          placeholder="policy name"
          :required="true"
          :validation-error="errorFor('name')"
      />

      <TextareaField
          label="Description"
          v-model="form.description"
          placeholder="Description"
          :required="true"
          :validation-error="errorFor('description')"
      />

      <div class="d-flex">
        <div class="column">
          <h6>Service</h6>
          <div class="column-item">
            <div
                class="item"
                v-for="service in services"
                :key="service.id"
                @click="selectService(service)"
                :class="{ active: service.id === selectedService.id }"
            >
              {{ service.name }}
            </div>
            <v-errors :errors="errorFor('service_id')"></v-errors>
          </div>
        </div>
        <div class="column">
          <h6>Sub Service</h6>
          <div class="column-item">
            <div
                class="item"
                v-for="subService in selectedService?.cloudSubServices"
                :key="subService.id"
                @click="selectSubService(subService)"
                :class="{ active: subService.id === selectedSubService.id }"
            >
              {{ subService.name }}
            </div>
            <v-errors :errors="errorFor('sub_service_id')"></v-errors>
          </div>
        </div>
        <div class="column">
          <h6>Work</h6>
          <div class="column-item">
            <div
                class="item"
                v-for="work in selectedSubService?.cloud_works"
                :key="work.id"
                @click="selectWork(work)"
                :class="{ active: work.id === selectedWork.id }"
            >
              {{ work.name }}
            </div>
            <v-errors :errors="errorFor('work_id')"></v-errors>
          </div>
        </div>
<!--        <div class="column">
          <h6>Resources</h6>
          <div
              class="item"
              v-for="resource in selectedWork?.cloud_resources"
              :key="resource.id"
              :class="{ active: resource.id === selectedResource.id }"
              @click="selectResource(resource)"
          >
            {{ resource.name }}
          </div>
          <v-errors :errors="errorFor('resource_id')"></v-errors>
        </div>-->
        <div class="column">
          <h6>Resources</h6>
          <div class="column-item">
            <div
                class="item"
                v-for="resource in subServiceResources"
                :key="resource.id"
                :class="{ active: resource.id === selectedServiceResource.id }"
                @click="selectServiceResource(resource)"
            >
              <template v-if="resource.starting_port">
                {{ resource.starting_port }} - {{ resource.end_port }}
              </template>
              <template v-if="resource.public_ip">
                {{ resource.public_ip }}
              </template>
              <template v-else>
                {{ resource.name ?? resource.server_name }}
              </template>
            </div>
            <v-errors :errors="errorFor('resource_id')"></v-errors>
          </div>
        </div>
      </div>
      <div class="float-end my-3 me-2">
        <button type="button" class="btn btn-primary btn-sm" @click="addNewPermissions">+ Add</button>
      </div>

      <div class="my-3">
        <div class="mb-2">Added Permission</div>
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Service</th>
            <th>Sub Service</th>
            <th>Work</th>
            <th>Resource</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <template v-if="addedPermissions?.length">
            <tr v-for="(permission, index) in addedPermissions" :key="`permission_${index}`">
              <td>{{ permission.cloud_service.name }}</td>
              <td>{{ permission.cloud_sub_service.name }}</td>
              <td>{{ permission.cloud_work.name }}</td>
              <td>
                <template v-if="permission?.serviceResource">
                  <template v-if="permission?.serviceResource?.public_ip">
                    {{ permission?.serviceResource?.public_ip }}
                  </template>
                  <template v-else>
                    {{ permission?.serviceResource?.name ?? permission?.serviceResource?.server_name }}
                  </template>
                </template>
                <template v-else>
                  <template v-if="permission?.server_resource">
                    {{ permission?.server_resource?.server_name }}
                  </template>
                  <template v-if="permission?.disk_resource">
                    {{ permission?.disk_resource?.name }}
                  </template>
                  <template v-if="permission?.network_resource">
                    {{ permission?.network_resource?.public_ip }}
                  </template>
                  <template v-if="permission?.ssh_resource">
                    {{ permission?.ssh_resource?.name }}
                  </template>
                </template>
              </td>
              <td><a href="#" @click="deletePermission(permission)">Delete</a> </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <div class="my-4">
        <div class="d_flex_start">
          <button
              type="button"
              class="btn btn-primary btn-md width_100p"
              :disabled="lyLoading"
              @click="submit"
          >
            {{ editId ? 'Update' : 'Submit'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputGroup from "@/components/FormControl/InputGroupComponent.vue";
import TextareaField from "@/components/FormControl/TextareaFieldComponent.vue";

export default {
  name: 'PolicyForm',
  components: {TextareaField, InputGroup},
  props: ['closeModal', 'loadData', 'editId'],
  data() {
    return {
      lyLoading: false,
      form: {
      },
      services: [],
      selectedService: {},
      selectedSubService: {},
      selectedWork: {},
      selectedResource: {},
      subServiceResources: [],
      selectedServiceResource: {},
      addedPermissions: []
    }
  },
  created() {
    this.permissionList()
    if (this.editId) {
      this.getPolicy()
    }
  },
  methods: {
    getPolicy() {
      this.axios.get(`/policies/${this.editId}`)
          .then(({data}) => {
            let policy = data.data
            this.form.name = policy.name
            this.form.description = policy.description

            // let permission  = policy.policyPermission

            // this.setSelectedItems(permission.cloud_service_id, permission.cloud_sub_service_id, permission.cloud_work_id, permission.cloud_resource_id);

            // this.addedPermissions = data.data?.policyPermissions
            // Transform existing permissions to match new format
            this.addedPermissions = policy.policyPermissions.map(permission => ({
              cloud_service: {
                id: permission.cloud_service_id,
                name: permission.cloud_service.name
              },
              cloud_sub_service: {
                id: permission.cloud_sub_service_id,
                name: permission.cloud_sub_service.name
              },
              cloud_work: {
                id: permission.cloud_work_id,
                name: permission.cloud_work.name
              },
              serviceResource: permission.serviceResource || permission.server_resource || permission.network_resource || permission.disk_resource || permission.ssh_resource
            }))
          })
    },
    permissionList() {
      this.axios.get('/cloud-service-list')
          .then(({data}) => {
            this.services = data.data
            this.selectService(this.services[0])
          })
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let apiUrl;
      if (this.editId) {
        apiUrl = `policies/${this.editId}`;
        this.form._method = 'PUT'
      } else {
        apiUrl = `policies`;
      }

      // const extractedIds = this.extractUniqueIds(this.addedPermissions);
      // Transform permissions for API
      const transformedPermissions = this.addedPermissions.map(permission => ({
        cloud_service_id: permission.cloud_service.id,
        cloud_sub_service_id: permission.cloud_sub_service.id,
        cloud_sub_service: permission.cloud_sub_service,
        cloud_work_id: permission.cloud_work.id,
        resource: permission.serviceResource?.id
      }))

      this.axios.post(apiUrl, {
        ...this.form,
        services: transformedPermissions
      })
          .then(({data}) => {
            if (data.success) {
              this.loadData()
              this.showSuccessMsg(data.message);
              this.closeModal()
            } else {
              this.showFailMsg(data.message);
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    selectService(service) {
      this.selectedService = service
      this.selectSubService(service.cloudSubServices[0])
    },
    selectSubService(subService) {
      this.selectedSubService = subService
      this.selectWork(subService?.cloud_works[0])
      this.getResources(this.selectedService.id, subService?.id)
    },
    selectWork(work) {
      this.selectedWork = work;
      if (work?.cloud_resources && work?.cloud_resources.length > 0) {
        this.selectResource(work?.cloud_resources[0]);
      } else {
        this.selectedResource = {};
      }
    },
    selectResource(resource) {
      this.selectedResource = resource;
    },
    setSelectedItems(serviceId, subServiceId, workId, resourceId) {
      const service = this.services.find(s => s.id === serviceId);
      if (service) {
        this.selectService(service);

        const subService = service.cloudSubServices.find(ss => ss.id === subServiceId);
        if (subService) {
          this.selectSubService(subService);

          const work = subService.cloud_works.find(w => w.id === workId);
          if (work) {
            this.selectWork(work);

            const resource = work.cloud_resources.find(r => r.id === resourceId);
            if (resource) {
              this.selectResource(resource);
            }
          }
        }
      }
    },
    selectServiceResource(resource) {
      this.selectedServiceResource = resource;
    },
    getResources(service_id, sub_service_id){
      if (service_id && sub_service_id) {
        this.axios.post('/get-customer-service-resource', {
          service_id: service_id,
          sub_service_id: sub_service_id
        }).then(({ data }) => {
          this.subServiceResources = data.data
          if (this.subServiceResources?.length === 0) {
            this.selectedServiceResource = {}
          } else {
            // this.selectedServiceResource = data.data[0]
          }
        })
      } else {
        this.subServiceResources = []
      }
    },
    addNewPermissions() {

      if (!this.selectedSubService?.name) {
        this.showFailMsg('The selected service sub-service not found!');
        return
      }

      // Normalize the selected resource for comparison
      const normalizedResource = this.selectedServiceResource && {
        id: this.selectedServiceResource.id,
        name: this.selectedServiceResource.name,
        server_name: this.selectedServiceResource.server_name,
        public_ip: this.selectedServiceResource.public_ip
      }

      const newPermission = {
        cloud_service: {
          id: this.selectedService.id,
          name: this.selectedService.name
        },
        cloud_sub_service: {
          id: this.selectedSubService.id,
          name: this.selectedSubService.name
        },
        cloud_work: {
          id: this.selectedWork.id,
          name: this.selectedWork.name
        },
        serviceResource: normalizedResource
      }

      // Check for conflicts with existing "All" work permissions
      const hasConflictWithAllWork = this.addedPermissions.some(permission => {
        const sameService = permission.cloud_service.id === newPermission.cloud_service.id
        const sameSubService = permission.cloud_sub_service.id === newPermission.cloud_sub_service.id
        const sameResource = this.compareResources(permission.serviceResource, newPermission.serviceResource)

        // Check if existing permission has "All" work or new permission is "All"
        const existingIsAll = permission.cloud_work.name === 'All'
        const newIsAll = newPermission.cloud_work.name === 'All'

        return sameService && sameSubService && sameResource && (existingIsAll || newIsAll)
      })

      if (hasConflictWithAllWork) {
        if (newPermission.cloud_work.name === 'All') {
          // If trying to add "All" work permission
          if (confirm('There are existing specific work permissions for this resource. Selecting "All" will remove them. Continue?')) {
            // Remove all specific work permissions for this service/subservice/resource combination
            this.addedPermissions = this.addedPermissions.filter(permission => {
              const sameService = permission.cloud_service.id === newPermission.cloud_service.id
              const sameSubService = permission.cloud_sub_service.id === newPermission.cloud_sub_service.id
              const sameResource = this.compareResources(permission.serviceResource, newPermission.serviceResource)

              return !(sameService && sameSubService && sameResource)
            })
          } else {
            return
          }
        } else {
          // If trying to add specific work when "All" exists
          this.showFailMsg('Cannot add specific work permission. An "All" work permission already exists for this resource.')
          return
        }
      }

      // Check for duplicates including resource comparison
      const isDuplicate = this.addedPermissions.some(permission => {
        const sameService = permission.cloud_service.id === newPermission.cloud_service.id
        const sameSubService = permission.cloud_sub_service.id === newPermission.cloud_sub_service.id
        const sameWork = permission.cloud_work.id === newPermission.cloud_work.id
        const sameResource = this.compareResources(permission.serviceResource, newPermission.serviceResource)

        return sameService && sameSubService && sameWork && sameResource
      })

      const hasAllService = this.addedPermissions.some(permission => permission.cloud_service.name === 'All');

      if (hasAllService) {
        this.showFailMsg('Cannot add this permission. An "All" service permission is already added.');
        return;
      }

      const hasAllSubService = this.addedPermissions.some(permission =>
          permission.cloud_service.name === newPermission.cloud_service.name &&
          permission.cloud_sub_service.name === 'All'
      );

      if (newPermission.cloud_service.name !== 'All' && hasAllSubService) {
        this.showFailMsg('Cannot add this permission. An "All" sub-service permission is already added for this service.');
        return;
      }

      if (newPermission.cloud_service.name === 'All') {
        const services = this.addedPermissions.some(permission =>
            permission.cloud_service.id !== newPermission.cloud_service.id
        );

        if (services) {
          // Alert the user that selecting 'All' will remove the existing sub-services
          if (confirm('Selecting "All" will remove existing sub-services. Do you want to continue?')) {
            // Remove all sub-services for this service before adding 'All'
            this.addedPermissions = this.addedPermissions.filter(permission =>
                permission.cloud_service.id !== newPermission.cloud_service.id  &&
                permission.cloud_sub_service.id === newPermission.cloud_sub_service.id &&
                permission.cloud_service.name === 'All'
            );
          } else {
            return; // Cancel adding 'All' if the user doesn't confirm
          }
        }
      }

      // Handle "All" service case
      if (newPermission.cloud_service.name === 'All' && hasAllService &&
          this.addedPermissions.some(p => p.cloud_service.name !== 'All')) {
        if (confirm('Selecting "All" will remove existing services. Do you want to continue?')) {
          this.addedPermissions = []
        } else {
          return
        }
      }

      // Handle "All" sub-service case
      if (newPermission.cloud_sub_service.name === 'All') {
        const existingSubServices = this.addedPermissions.filter(p =>
            p.cloud_service.id === newPermission.cloud_service.id &&
            p.cloud_sub_service.name !== 'All'
        )

        if (existingSubServices.length > 0) {
          if (confirm('Selecting "All" will remove existing sub-services for this service. Continue?')) {
            this.addedPermissions = this.addedPermissions.filter(p =>
                p.cloud_service.id !== newPermission.cloud_service.id
            )
          } else {
            return
          }
        }
      }

      // Handle "All" work case with resource consideration
      if (newPermission.cloud_work.name === 'All') {
        const existingWorksForResource = this.addedPermissions.filter(p =>
            p.cloud_service.id === newPermission.cloud_service.id &&
            p.cloud_sub_service.id === newPermission.cloud_sub_service.id &&
            this.compareResources(p.serviceResource, newPermission.serviceResource) &&
            p.cloud_work.name !== 'All'
        )

        if (existingWorksForResource.length > 0) {
          if (confirm('Selecting "All" will remove existing works for this resource. Continue?')) {
            this.addedPermissions = this.addedPermissions.filter(p =>
                !(p.cloud_service.id === newPermission.cloud_service.id &&
                    p.cloud_sub_service.id === newPermission.cloud_sub_service.id &&
                    this.compareResources(p.serviceResource, newPermission.serviceResource))
            )
          } else {
            return
          }
        }
      }

      if (!isDuplicate) {
        this.addedPermissions.push(newPermission)
      } else {
        this.showFailMsg('Permission already added')
      }
    },

    compareResources(resource1, resource2) {
      if (!resource1 && !resource2) return true
      if (!resource1 || !resource2) return false

      // Compare all possible resource identifiers
      return resource1.id === resource2.id ||
          (resource1.server_name && resource1.server_name === resource2.server_name) ||
          (resource1.public_ip && resource1.public_ip === resource2.public_ip)
    },
    deletePermission(permissionToDelete) {
      this.addedPermissions = this.addedPermissions.filter(permission =>
          !(permission.cloud_service === permissionToDelete.cloud_service &&
              permission.cloud_sub_service === permissionToDelete.cloud_sub_service &&
              permission.cloud_work === permissionToDelete.cloud_work &&
              permission.serviceResource === permissionToDelete.serviceResource)
      );
    },
    extractUniqueIds(permissionsData) {
      const uniqueIds = {
        serviceIds: new Set(),
        subServiceIds: new Set(),
        workIds: new Set(),
        serviceResourceIds: new Set()
      };

      permissionsData.forEach(permission => {
        if (permission.service && permission.service.id) {
          uniqueIds.serviceIds.add(permission.service.id);
        }
        if (permission.subService && permission.subService.id) {
          uniqueIds.subServiceIds.add(permission.subService.id);
        }
        if (permission.work && permission.work.id) {
          uniqueIds.workIds.add(permission.work.id);
        }
        if (permission.serviceResource && permission.serviceResource?.id) {
          uniqueIds.serviceResourceIds.add(permission.serviceResource?.id);
        }
      });

      return {
        serviceIds: Array.from(uniqueIds.serviceIds),
        subServiceIds: Array.from(uniqueIds.subServiceIds),
        workIds: Array.from(uniqueIds.workIds),
        serviceResourceIds: Array.from(uniqueIds.serviceResourceIds)
      };
    },
  }
}
</script>
<style scoped>
.column {
  flex: 1;
  margin: 0 10px;
}
.column-item {
  height: 300px;
  border: solid 1px #ddd;
  overflow: auto;
}
.column-item::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.column-item:hover::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.column-item:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px; /* Rounded corners */
}

.column-item:hover::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}
.column-item {
  scrollbar-width: none;
}

.column-item:hover {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.1);
}

h6 {
  padding: 10px;
  margin: 0;
}

.item {
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  padding: 10px;
  margin-top: -1px;
  cursor: pointer;
}

.item:hover {
  background-color: #e0e0e0;
}

.item.active {
  background-color: #bbdefb;
}
</style>
  